module.exports = __webpack_public_path__ + "static/media/Ellipse.b52cfafc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/Ellipse.png
// module id = ./src/assets/media/icons/Ellipse.png
// module chunks = 16